import { useGlobalContext } from "context/GlobalContext";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  EmailIcon,
  LinkedinIcon,
  RedditIcon,
  TelegramIcon,
  WhatsappIcon,
} from "react-share";

const url = window.location.origin;
const content = `Hola, checa esta nueva plataforma: `;

const data = {
  url,
  title: "La app para un mejor México.",
  quote: content,
  description: content,
};

export const DrawerShared = () => {
  const gContext = useGlobalContext();

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={gContext.openShared}
      onClose={gContext.toggleOpenShared}
      onOpen={gContext.toggleOpenShared}
    >
      <div className="bottom" role="presentation">
        <List>
          <FacebookShareButton
            url={data.url}
            quote={data.quote}
            description={data.description}
            className="share-button"
          >
            <ListItem button>
              <ListItemIcon>
                <FacebookIcon size={32} round />
              </ListItemIcon>
              <ListItemText primary="Facebook" />
            </ListItem>
          </FacebookShareButton>
          <br />
          <TwitterShareButton
            title={data.description}
            url={data.url}
            className="share-button"
          >
            <ListItem button>
              <ListItemIcon>
                <TwitterIcon size={32} round />
              </ListItemIcon>
              <ListItemText primary="Twitter" />
            </ListItem>
          </TwitterShareButton>
          <br />
          <EmailShareButton
            subject={data.title}
            body={data.description}
            url={data.url}
            className="share-button"
          >
            <ListItem button>
              <ListItemIcon>
                <EmailIcon size={32} round />
              </ListItemIcon>
              <ListItemText primary="Correo" />
            </ListItem>
          </EmailShareButton>
          <br />
          <LinkedinShareButton
            title={data.title}
            summary={data.description}
            url={data.url}
            source={data.url}
            className="share-button"
          >
            <ListItem button>
              <ListItemIcon>
                <LinkedinIcon size={32} round />
              </ListItemIcon>
              <ListItemText primary="Linkedin" />
            </ListItem>
          </LinkedinShareButton>
          <br />
          <RedditShareButton
            title={data.description}
            url={data.url}
            className="share-button"
          >
            <ListItem button>
              <ListItemIcon>
                <RedditIcon size={32} round />
              </ListItemIcon>
              <ListItemText primary="Reddit" />
            </ListItem>
          </RedditShareButton>
          <br />
          <TelegramShareButton
            title={data.description}
            url={data.url}
            className="share-button"
          >
            <ListItem button>
              <ListItemIcon>
                <TelegramIcon size={32} round />
              </ListItemIcon>
              <ListItemText primary="Telegram" />
            </ListItem>
          </TelegramShareButton>
          <br />
          <WhatsappShareButton
            title={data.description}
            url={data.url}
            className="share-button"
          >
            <ListItem button>
              <ListItemIcon>
                <WhatsappIcon size={32} round />
              </ListItemIcon>
              <ListItemText primary="Whatsapp" />
            </ListItem>
          </WhatsappShareButton>
        </List>
        <Divider />
      </div>
    </SwipeableDrawer>
  );
};
